import React, { Component } from "react";
import MinNav from "../component/MinNav";
import NewsLetterTable from "./NewsLetterTable";
import NewsLetterEditor from "./../../editors/NewsLetterEditor";
import { ReactComponent as CloseSVG } from "./../../images/svg/close.svg";

class AllNewsLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      storeState: true
    };

    this.postDelete = this.postDelete.bind(this);
    this.sendNewsletter = this.sendNewsletter.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ storeState: false });
    let searchValues = e.target.value;
    fetch(`${this.props.apiROOT}newsletter/search/${searchValues}`)
      .then(res => res.json())
      .then(data => {
        if (data.posts.length > 0) {
          this.setState({ posts: data.posts });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  postDelete(e) {
    if (window.confirm('Delete this newsletter')) {
      let postID = e.target.getAttribute("data-id");
      fetch(`${this.props.apiROOT}newsletter/delete/${postID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            //eslint-disable-next-line
            this.state.posts.map((p, i) => {
              if (p.post_id === postID) {
                delete this.state.posts[i];
              }
            });
            this.setState({ posts: this.state.posts });
          }
        });
    }
  }

  sendNewsletter(e) {
    if (window.confirm('Send this newsletter')) {
      let postID = e.target.getAttribute("data-id");
      fetch(`${this.props.apiROOT}newsletter/sendNewsletter/${postID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            //eslint-disable-next-line
            this.state.posts.map((p, i) => {
              if (p.post_id === postID) {
                let sent = parseInt(this.state.posts[i].sent);
                if (sent === 0) {
                  //eslint-disable-next-line
                  this.state.posts[i].sent = 1;
                } else {
                  //eslint-disable-next-line
                  this.state.posts[i].sent = 0;
                }
              }
            });
            this.setState({ posts: this.state.posts });
          }
        });
    }
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}newsletter/adminPost`)
      .then(res => res.json())
      .then(data => {
        if (data.posts == null) return;
        this.setState({
          posts: data.posts
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="a-container">
        <MinNav />
        <div className="" style={{ width: 200 + "px", margin: 10 + 'px auto' }}>
          <a href="#">
            <button className="btn shadow"
              onClick={this.props.toggleNewsletterEditor}
              style={{ margin: 10 + ' auto', backgroundColor: 'green' }}>Create Newsletter</button>
          </a>
        </div>
        <div style={{ padding: 5 + "px " + 1 + "%", margin: 10 + 'px auto' }}>
          <input
            placeholder="Search post title, post ID..."
            onChange={this.onChange}
            style={{ background: "#f9f9f9", width: 80 + "%", margin: 10 + 'px auto', display: 'block' }}
          />
        </div>

        <NewsLetterTable
          posts={this.state.posts}
          apiROOT={this.props.apiROOT}
          postDelete={this.postDelete}
          sendNewsletter={this.sendNewsletter}
        />

        <div className="newsletter-editor-wrapper hide">
          <span
            className="newsletter-editor-wrapper-close"
            onClick={this.props.toggleNewsletterEditor}
          >
            <CloseSVG /> Close
          </span>

          <NewsLetterEditor
            apiROOT={this.props.apiROOT}
            root={this.props.root}
            post_title=""
            post_tags=""
            setter="insert"
          />
        </div>
      </div>
    );
  }
}

export default AllNewsLetter;
